import { generatePath as routerGeneratePath } from 'react-router';
export const generatePath = (space, params, queryParams) => {
    var _a;
    const spacePath = `/${(_a = space === null || space === void 0 ? void 0 : space.address) === null || _a === void 0 ? void 0 : _a.path}`;
    const path = params ? routerGeneratePath(spacePath, params || {}) : spacePath;
    const encodedURI = queryParams
        ? `${path}?${new URLSearchParams(queryParams).toString()}`
        : path;
    return decodeURI(encodedURI);
};
export const generateMemberPath = (memberSpace, member) => memberSpace && member
    ? generatePath(memberSpace, { id: member.id || '' })
    : '/';
export const generatePostPath = (postSpace, space, post, reply) => postSpace && space && post
    ? generatePath(postSpace, {
        spacePath: generatePath(space).slice(1),
        postPath: post.slug ? `${post.slug}-${post.id}` : post.id,
    }, (reply === null || reply === void 0 ? void 0 : reply.id) ? { highlight: reply === null || reply === void 0 ? void 0 : reply.id } : null)
    : '/';
//# sourceMappingURL=space.utils.js.map